import React from 'react';

export type FMSource = 'MCP' | 'MCA';

interface JetFMContextValue {
  featureManagement: Partial<Record<FMSource, Object>>;
}

const JetFMContext = React.createContext<JetFMContextValue>({ featureManagement: {} });
export const JetFMContextProvider = JetFMContext.Provider;
export default JetFMContext;
